"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _base = require("./base");

var _NavSearch = _interopRequireDefault(require("./NavSearch"));

var _NavLinksCreate = _interopRequireDefault(require("./NavLinksCreate"));

var _NavLinksCollection = _interopRequireDefault(require("./NavLinksCollection"));

var _NavLinksUser = _interopRequireDefault(require("./NavLinksUser"));

var _icons = _interopRequireDefault(require("../styles/icons"));

var _theme = require("../styles/theme");

var _themeNav = require("./theme-nav");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var NavTouchIcon = (
/*#__PURE__*/
0, _styledBase.default)('div', {
  target: "e1h2vgca0",
  label: "NavTouchIcon"
})("display:none;padding:0 20px;text-align:center;position:absolute;left:0px;&::after{", _theme.fonts.icons, ";content:'", function (_ref) {
  var mobilemenu = _ref.mobilemenu;
  return mobilemenu ? _icons.default.x : _icons.default['touch-nav'];
}, "';color:", _themeNav.navItemColor, ";line-height:", _themeNav.navHeight, ";font-size:", _theme.fonts.sans.size.xlarge, ";}&:hover{cursor:pointer;&::after{color:", _themeNav.navItemHoverColor, ";}}@media screen and (max-width:1000px){display:block;& + ", _base.NavInnerWrapper, "{right:", function (_ref2) {
  var mobilemenu = _ref2.mobilemenu;
  return mobilemenu ? 0 : '-220px';
}, ";}}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

var NavTouch =
/*#__PURE__*/
function (_Component) {
  _inherits(NavTouch, _Component);

  function NavTouch(props) {
    var _this;

    _classCallCheck(this, NavTouch);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NavTouch).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "toggleMenu", function () {
      var mobilemenu = _this.state.mobilemenu;
      var toggleState = !mobilemenu;

      _this.setState({
        mobilemenu: toggleState
      });
    });

    _this.state = {
      mobilemenu: props.mobilemenu || false
    };
    return _this;
  }

  _createClass(NavTouch, [{
    key: "render",
    value: function render() {
      var otherProps = _extends({}, this.state);

      return _react.default.createElement(NavTouchIcon, _extends({
        onClick: this.toggleMenu
      }, otherProps));
    }
  }]);

  return NavTouch;
}(_react.Component);

NavTouch.defaultProps = {
  mobilemenu: false,
  onChange: function onChange() {}
};
NavTouch.propTypes = {
  mobilemenu: _propTypes.default.bool,
  onChange: _propTypes.default.func
};

var Nav = function Nav(props) {
  var basic = props.basic,
      align = props.align,
      theme = props.theme,
      onSearch = props.onSearch,
      searchPlaceholder = props.searchPlaceholder,
      ready = props.ready,
      avatarUrl = props.avatarUrl,
      _props$data = props.data,
      primaryLinks = _props$data.primaryLinks,
      createLinks = _props$data.createLinks,
      secondaryLinks = _props$data.secondaryLinks,
      userLinks = _props$data.userLinks;

  var createLinksExist = function createLinksExist() {
    return createLinks.length > 0;
  };

  return _react.default.createElement(_emotionTheming.ThemeProvider, {
    theme: {
      mode: theme
    }
  }, _react.default.createElement(_base.NavWrapper, {
    ready: ready
  }, _react.default.createElement(NavTouch, null), _react.default.createElement(_base.NavInnerWrapper, {
    align: align
  }, basic ? _react.default.createElement(_NavLinksCollection.default, {
    links: secondaryLinks
  }) : _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_NavLinksCollection.default, {
    links: primaryLinks,
    mobileorder: "4"
  }), _react.default.createElement(_NavSearch.default, {
    onSearch: onSearch,
    placeholder: searchPlaceholder,
    mobileorder: "1"
  }), createLinksExist(createLinks) && _react.default.createElement(_NavLinksCreate.default, {
    links: createLinks,
    mobileorder: "3"
  }), _react.default.createElement(_NavLinksCollection.default, {
    links: secondaryLinks,
    mobileorder: "4"
  }), _react.default.createElement(_NavLinksUser.default, {
    links: userLinks,
    avatarUrl: avatarUrl,
    mobileorder: "1"
  })))));
};

var linkShape = _propTypes.default.shape({
  name: _propTypes.default.string,
  path: _propTypes.default.string,
  children: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.shape({
    name: _propTypes.default.string,
    path: _propTypes.default.string
  }), _propTypes.default.arrayOf(_propTypes.default.shape({
    name: _propTypes.default.string,
    path: _propTypes.default.string
  }))]))
});

var linkCollectionShape = _propTypes.default.arrayOf(_propTypes.default.oneOfType([linkShape, _propTypes.default.arrayOf(linkShape)]));

Nav.defaultProps = {
  basic: false,
  align: 'left',
  theme: 'default',
  ready: true,
  avatarUrl: undefined,
  onSearch: null,
  searchPlaceholder: ''
};
Nav.propTypes = {
  basic: _propTypes.default.bool,
  align: _propTypes.default.string,
  theme: _propTypes.default.string,
  ready: _propTypes.default.bool,
  onSearch: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
  searchPlaceholder: _propTypes.default.string,
  data: _propTypes.default.shape({
    primaryLinks: linkCollectionShape.isRequired,
    createLinks: linkCollectionShape.isRequired,
    secondaryLinks: linkCollectionShape.isRequired,
    userLinks: linkCollectionShape.isRequired
  }).isRequired,
  avatarUrl: _propTypes.default.string
};
var _default = Nav;
exports.default = _default;